export default (num?: number) => {
  if (!num) {
    return '0%';
  }

  return `${Math.round(num * 100)}%`;
};
